import { render } from "./MasterPatrols.vue?vue&type=template&id=04a883c6&scoped=true"
import script from "./MasterPatrols.vue?vue&type=script&lang=js"
export * from "./MasterPatrols.vue?vue&type=script&lang=js"

import "./MasterPatrols.vue?vue&type=style&index=0&id=04a883c6&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a883c6"]])

export default __exports__